<ng-container [ngSwitch]="true">
  <ng-container *ngSwitchCase="operationalView">
    <sn-operational-grid-view
      [allowTimeout]="allowTimeout"
      [meta]="cameraGrid.metaData"
      [cameras]="cameraGrid.cameras"
      [autoplay]="cameraGrid.autoplay"
      [hideBottom]="hideBottom"
      (cameraStreamPlay)="onCameraStreamPlay($event)"
      (cameraStreamPause)="onCameraStreamStop($event)"
      (cameraStreamStop)="onCameraStreamStop($event)"
      (gridSession)="gridSession.next($event)"
    >
    </sn-operational-grid-view>
  </ng-container>
  <ng-container *ngSwitchCase="bulkSearch">
    <sn-camera-grid
      [cols]="cameraGrid.geometry.cols"
      [rows]="cameraGrid.geometry.rows"
      [bulkSearch]="bulkSearch"
      [allowTimeout]="allowTimeout"
      [cameras]="cameraGrid.cameras"
      [autoplay]="true"
      [hideBottom]="hideBottom"
      [meta]="cameraGrid.metaData"
      (orderChanged)="onOrderChanged($event)"
      (cameraStreamPlay)="onCameraStreamPlay($event)"
      (cameraStreamPause)="onCameraStreamStop($event)"
      (cameraStreamStop)="onCameraStreamStop($event)"
      (gridSession)="gridSession.next($event)"
      (dateChange)="dateChange.next($event)"
    >
    </sn-camera-grid>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <sn-camera-grid
      [cols]="cameraGrid.geometry.cols"
      [rows]="cameraGrid.geometry.rows"
      [meta]="cameraGrid.metaData"
      [allowTimeout]="allowTimeout"
      [cameras]="cameraGrid.cameras"
      [autoplay]="cameraGrid.autoplay"
      [hideBottom]="hideBottom"
      (orderChanged)="onOrderChanged($event)"
      (gridSession)="gridSession.next($event)"
      (cameraStreamPlay)="onCameraStreamPlay($event)"
      (cameraStreamPause)="onCameraStreamStop($event)"
      (cameraStreamStop)="onCameraStreamStop($event)"
    >
    </sn-camera-grid>
  </ng-container>
</ng-container>
